export const TermsType = Object.freeze({
  ALL: "ALL",
  ESSENTIAL: "ESSENTIAL",
  OPTIONAL: "OPTIONAL"
});
